import React, { useState } from 'react';
import AppelerApi from '../../../services/appeler-api.service';
import './formulaireConnexion.scss';

const FormulaireConnexion = ({ surConnexion }) => {
    const [identifiant, setIdentifiant] = useState('');
    const [motDePasse, setMotDePasse] = useState('');
    const [erreur, setErreur] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const reponse = await AppelerApi.post('/connexion',
                {
                    Identifiant_utilisateur: identifiant,
                    Mdp_utilisateur: motDePasse
                },
                (window.location.hostname.includes('localhost') || window.location.hostname.includes('test')) ? 'DEV' : 'PROD'
            );
            if (reponse.codeHttp) {
                setErreur(reponse.erreur);
            } else {
                localStorage.setItem('utilisateur', identifiant);
                surConnexion(reponse);
            }
        } catch (error) {
            console.error('Erreur lors de la requête de connexion:', error);
            setErreur('Erreur lors de la connexion.');
        }
    };

    return (
        <div className="conteneur-formulaireConnexion">
            <form className="formulaire-connexion" onSubmit={handleSubmit}>
                <h2>Connexion</h2>
                <div className="groupe-formulaire">
                    <label htmlFor="username">Identifiant :</label>
                    <input
                        type="text"
                        id="username"
                        name="username"
                        autoComplete="username"
                        value={identifiant}
                        onChange={(e) => setIdentifiant(e.target.value)}
                        required
                    />
                </div>
                <div className="groupe-formulaire">
                    <label htmlFor="password">Mot de Passe :</label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        autoComplete="current-password"
                        value={motDePasse}
                        onChange={(e) => setMotDePasse(e.target.value)}
                        required
                    />
                </div>
                <button type="submit">Se Connecter</button>
            </form>
            {erreur && <p style={{ color: 'red' }}>{erreur}</p>}
        </div>
    );
};

export default FormulaireConnexion;